import { Injectable } from '@angular/core';

import { Model } from '../shared/model';
import { Controller } from './controller.model';
import { Location } from '../locations/location.model';
import { Organization } from '../organization/organization.model';

const DeviceMap = {
  'name': 'label'
}

@Injectable()
export class Device extends Model {

  // properties
  id                  : number
  code                : string
  name                : string
  org_id              : number
  location_id         : number
  location           ?: Location
  org                ?: Organization
  vpn_port            : string
  vpn_ip              : string
  subnet_mask         : string
  relay_controller_id ?: number | null
  hologram_device_id  : string
  mssfix              : boolean = true
  online              : boolean = false
  remote              : boolean = true
  disabled_for_ordinary_users             : boolean = false
  cell_org_id         : number
  cell_state          : string
  cell_limit          : any
  cell_usage          : any
  sim                 ?: string

  rssi_value          : number
  connection_type     : string

  status              : string
  editing             : boolean = false
  selected            : boolean = false
  connection_status   : string = 'disconnected'
  ui_state            : string

  // Children
  connections         : Controller[] = []
  connection         ?: Controller
  ports              ?: any = null

  serial             ?: any

  getIpsLength       ?: any

  constructor(obj: Device) {
    super(obj);
    if(obj.connections) obj.connections = obj.connections.map(connection => new Controller(connection));
    Object.assign(this, obj);

    this.getIpsLength = () => {
       return this.connections.reduce((x, c) => x + c.ips.length, 0);
    }
  }
}
